<template>
  <div class="container middle">
        <button class="back-button" v-on:click="previousPage()">Back</button>
    <div class="mid-container">
    <h1>Create new route</h1>

    </div>
    <div class="button-container">
      <div class="buttons">
        <button class="my-races-button" v-on:click="plotRoute()">Plot a route</button>
        <button class="new-race-button" v-on:click="importGpx()">Import gpx</button>
        <button class="distance-based-button" v-on:click="newRace()">Distance based</button>
      </div>
    </div>

  </div>
</template>

<script>

import { userRef } from '../firebase'
import firebase from 'firebase'
import { store } from '../store/store'
import { mapGetters } from 'vuex'

export default {
  name: 'mainMenu',
  title: 'Runner - Menu',
  created() {
  //  this.$store.dispatch('setPlannerSpeedDialRef', userRef.child(firebase.auth().currentUser.uid).child('plannerSpeedDial'))
  },
  computed: {
    ...mapGetters([ 'races' ]),
    currentUserEmail() {
      return firebase.auth().currentUser.email
    }
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        console.log("Logging out")
        this.$router.replace('login')
      })
    },
    newRace() {
      this.$router.replace('createDistanceRoute')
    },
    myRaces() {
      this.$router.replace('myraces')
    },
    importGpx() {
     this.$router.replace('gpxImport')
    },
    plotRoute() {
     this.$router.replace('plotter')
    },
    previousPage() {
     this.$router.replace('myraces')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '../styles/styles.scss';

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-top:10px;
      width: 80px;
      height: 80px;
    }
  }
  h1 {
    color: $blackgrey;
  }

  .mid-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;
    align-items: center;
    flex: 3;

    .header-container{

      margin-top: 20px;

      .header-text {
        font-size: $font-large;
        font-weight: bold;
        margin: 0 0;
        color: $cyan;
        font-family: $opensans;
        font-size: 26px;
      }
    }



    p {
      font-size: $font-semiSemiLarge;
    }

  }

  .links {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    flex: 1;

    .link {
      text-decoration: underline;
      font-size: $font-semiSemiLarge;
      cursor: pointer;
    }

    .link.learn-more {
      color: $cyan;
      margin-bottom: 20px;
    }

    .logged-container {

      margin-bottom: 10px;

      .email {
        font-weight: 700;
      }
    }
  }

  .button-container {
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: flex-end;
  }

  .button-container .buttons {
    display: flex;
    flex-direction: row;
    flex: 1 100%;
    justify-content: space-between;
  }

  button {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 40%;
    color: white;
    border: none;
    border-radius: 8px;
    align-self: center;
    font-size: $font-semiSemiLarge;
    font-weight: bold;
  }

  .my-races-button {
    background-color: $blackgrey;
    max-width: 200px;
  }

  .back-button {
    position:absolute;
    top: 20px;
    left: 30px;
    background-color: $cyan-light;
    max-width: 75px;
  }

  .new-race-button {
    background-color: $cyan;
    max-width: 200px;
  }
  .distance-based-button {
    background-color: $blackgrey;
    max-width: 200px;
  }

  @media screen and (min-width: 1140px) {
    .image-container {
      img {
        position: absolute;
        top: -55px;
        z-index: 99;
        width: 110px;
        height: 110px;
      }
    }

    .mid-container {
      flex: 2;
    }

    .mid-container {
      justify-content: flex-start;
    }

    .container.middle {
      padding: 30px;
    }

  }

  @media screen and (max-width: 1140px) {
    .container {
      padding-left: 10%;
    	padding-right: 10%;
    	padding-bottom: 30px;
      background-color: white;
    }


  }

</style>
